import { useEffect } from 'react';
import { CookieUtil, useApi } from '@axiom/ui';

import { WindowUtil } from '../../utils/window-util';
import { UserLegacyApi } from '../../api/user-legacy-api';

export const PendoProvider = () => {
  const [{ data: user } = { data: null }] = useApi(
    CookieUtil.isUserExpired() ? undefined : UserLegacyApi.readUser()
  );

  useEffect(() => {
    if (typeof WindowUtil.initializePendo === 'function') {
      WindowUtil.initializePendo(user === null ? undefined : { user });
    }
  }, [WindowUtil.initializePendo, user]);

  return null;
};
